var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeighting01 = function SvgWeighting01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weighting-01_svg2__a",
    x1: 36.36,
    x2: 239.65,
    y1: 209.83,
    y2: 40.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M194.14 173.54h-2.44V20.6c0-3.24-2.62-5.86-5.86-5.86h-43.65c-3.24 0-5.86 2.62-5.86 5.86v152.93h-8.64V77.47c0-3.24-2.62-5.86-5.86-5.86H78.18c-3.24 0-5.86 2.62-5.86 5.86v96.06h-8.64v-39.19c0-3.23-2.62-5.86-5.86-5.86H14.16c-3.24 0-5.86 2.62-5.86 5.86v39.19H5.86c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h188.28c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86Zm-174.12 0v-33.33h31.93v33.33zm64.01 0v-90.2h31.93v90.2zm64.01 0V26.46h31.93v147.07h-31.93Z",
    style: {
      fill: "url(#weighting-01_svg2__a)"
    }
  }));
};
export default SvgWeighting01;